/**
 * The row a first-row fallback presses when typing left nothing highlighted:
 * the first enabled value row. Action rows (create, clear, revert) are skipped
 * so a search with no matches never runs one by accident.
 */
export const firstPressableRow = (
    popup: HTMLElement | null | undefined,
): HTMLElement | null => {
    const row = popup?.querySelector(
        '[role="option"]:not([data-disabled]):not([data-action-item])',
    );
    return row instanceof HTMLElement ? row : null;
};
